import React from 'react';
import './Home.css';
import BannerImg from '../../images/bingo-header.png';

function Home() {
    return (
        <div className="home-container">
            <div className="home-card">
                <div className="home-banner-wrapper">
                    <img src={BannerImg} alt="Banner Quermesse São Benedito" className="home-banner-img" />
                </div>
                <h1 className="home-title">Sistema de Bingo</h1>
                <p className="home-subtitle">Selecione uma das opções abaixo para iniciar a transmissão</p>

                <div className="home-actions">
                    <a href="/Sorteio" target="_blank" rel="noopener noreferrer" className="home-btn btn-sorteio">
                        <span className="btn-icon">🎯</span>
                        <div className="btn-content">
                            <span className="btn-title">Painel de Sorteio</span>
                            <span className="btn-desc">Controle de sorteio e gerenciamento de rodadas</span>
                        </div>
                    </a>

                    <a href="/Bingo" target="_blank" rel="noopener noreferrer" className="home-btn btn-bingo">
                        <span className="btn-icon">📺</span>
                        <div className="btn-content">
                            <span className="btn-title">Tela de Projeção</span>
                            <span className="btn-desc">Exibição pública das bolas sorteadas para o projetor</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Home;
